import { action, observable } from 'mobx';
import { api } from '../config';

// Components
import SessionStore from './SessionStore';

let obx = observable({
  packages: [],
  selectedPackage: {},
  selectedPackageSids: [],
  resetPackages: action(function(){
    obx.packages = [];
    obx.selectedPackage = {};
  }),
  // List all review packages
  getReviewPackages: action(function(){
    SessionStore.startLoading('Loading…', 'GetReviewPackages');

    // Reset package data
    obx.resetPackages();

    api.get(`proctors/${SessionStore.userData.proctorAccountSid}/reviewPackages`)
      .then(response => {
        obx.packages = response.data.results;
        SessionStore.finishLoading('Loading…', 'GetReviewPackages');
      })
      .catch(error => {
        SessionStore.throwError(error);
      })
  }),
  // Get in-progress review package
  getCurrentReviewPackage: action(function(){
    SessionStore.startLoading('Loading…', 'getCurrentReviewPackage');

    // Reset package data
    obx.resetPackages();

    api.get(`proctors/${SessionStore.userData.proctorAccountSid}/reviewPackages?limit=1&status=incomplete`)
      .then(response => {
        if(response.data.results.length > 0) {
          obx.packages = response.data.results;
        } else {
          obx.getNextReviewPackage();
        }

        SessionStore.finishLoading('Loading…', 'getCurrentReviewPackage');
      })
      .catch(error => {
        SessionStore.throwError(error);
      })
  }),
  // Get the next available review package
  getNextReviewPackage: action(function(){
    SessionStore.startLoading('Loading…', 'GetNextReviewPackage');

    // Reset package data
    obx.resetPackages();

    api.get(`proctors/${SessionStore.userData.proctorAccountSid}/nextReviewPackage?limit=1`)
      .then(response => {
        obx.packages = response.data.results;
        SessionStore.finishLoading('Loading…', 'GetNextReviewPackage');
      })
      .catch(error => {
        SessionStore.throwError(error);
      })
  }),
  // Get package access keys
  getPackageSessions: action(function(packageSid, callback){
    SessionStore.startLoading('Loading…', 'GetPackageSessions');

    api.get(`proctors/${SessionStore.userData.proctorAccountSid}/reviewPackages/${packageSid}`)
      .then(response => {
        obx.selectedPackage = response.data;

        // Loop through the package sessions to get the access keys
        obx.selectedPackage.sessions.forEach(function(session){
          if(session) {
            obx.selectedPackageSids.push(session.accessKey)
          }
        });

        if(callback) {
          callback();
        }

        SessionStore.finishLoading('Loading…', 'GetPackageSessions');
      })
      .catch(error => {
        SessionStore.throwError(error);
      })
  }),
  // Claim package
  claimPackage: action(function(packageSid, callback){
    SessionStore.startLoading('Loading…', 'ClaimPackage');

    const data = {
      proctorUserSid: SessionStore.userData.sid
    }

    api.post(`proctors/${SessionStore.userData.proctorAccountSid}/reviewPackages/${packageSid}`, data)
      .then(response => {
        // Get the access keys for the sessions in the claimed package
        obx.getPackageSessions(packageSid, callback);

        SessionStore.finishLoading('ClaimPackage');
      })
      .catch(error => {
        SessionStore.throwError(error);
      })
  })
});

export default obx;



// WEBPACK FOOTER //
// ./src/app/stores/ReviewStore.js